module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<textarea class="textfield sms" placeholder="SMS message"\n    style="width: 80%; height: 40px;" cols="140" rows="3"></textarea>\n<div class="dim">\n    <span class="sms-count"></span>/'+
((__t=( sms_length ))==null?'':_.escape(__t))+
'\n    (Cost <span class="cost"></span>)\n</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./messaging/templates/sms.html
// module id = 285
// module chunks = 0